export default {
  ShowNotification: 'SHOW_NOTIFICATION',
  HideNotification: 'HIDE_NOTIFICATION'
}
